import script from "./PlayerWrap.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerWrap.vue?vue&type=script&setup=true&lang=js"

import "./PlayerWrap.vue?vue&type=style&index=0&id=994aaa02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-994aaa02"]])

export default __exports__